export enum RiskLevelEnum {
	low = 'low',
	moderate = 'moderate',
	high = 'high',
}
